module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('div', {
    staticClass: "imag_1"
  }, [_c('img', {
    attrs: {
      "alt": "figure",
      "src": "images/pa.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("A Sturmgeschütz IV of SS-Panzer-Abteilung 17 photographed in Normandy during the summer of 1944. Note the Panzer rhomboid tactical sign and company number on the left side front fender. This vehicle is also depicted in the Camouflage & Markings section on page 18.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bc0edd4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/02_Photo.vue
// module id = 57
// module chunks = 0